import * as React from "react";
import { themeClassName } from "../utils/theme";

const LogoIcon = (
  props: React.SVGProps<SVGSVGElement> & { mode?: "dark" | "light" },
) => {
  const theme = themeClassName();

  if (theme === "itexchangenet") {
    return (
      <img
        src="/itexchangenet-icon.png"
        alt="IT ExchangeNet"
        className={props.className}
        width={props.width ?? 24}
        height={props.height ?? 24}
        style={{
          objectFit: "contain",
          display: "block",
          ...(props.style as React.CSSProperties | undefined),
        }}
      />
    );
  }

  if (theme === "carson") {
    return (
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 446 446"
        {...props}
      >
        <defs>
          <style>
            {`
      .cls-1 {
        fill: #0094d9;
      }

      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {
        stroke-width: 0px;
      }

      .cls-2 {
        fill: #0086bd;
      }

      .cls-3 {
        fill: #0077c1;
      }

      .cls-4 {
        fill: #0095d4;
      }

      .cls-5 {
        fill: #3ca7dd;
      }

      .cls-6 {
        fill: #72bde0;
      }

      .cls-7 {
        fill: #00a4e3;
      }

      .cls-8 {
        fill: #005e98;
      }

      .cls-9 {
        fill: #006db0;
      }

      .cls-10 {
        fill: #00477d;
      }

      .cls-12 {
        font-family: Avenir-Book, Avenir;
        font-size: 41.5px;
      }

      .cls-12, .cls-11 {
        fill: #fff;
      }
      `}
          </style>
        </defs>

        <g transform=" translate(-250, -300)">
          <path
            className="cls-2"
            d="M371.9,386.7c73.6-59.5,181.6-48,241.1,25.6,41.1,50.9,48.3,118.3,24.5,174.6,37.4-60.2,34.7-139.9-12.3-198.1-59.5-73.7-167.4-85.1-241.1-25.6-15.8,12.8-27.5,29.9-35.6,49.8,6.5-10,14.3-18.9,23.4-26.3"
          />
          <path
            className="cls-4"
            d="M401.9,417.1c4.1-5.4,8.7-10.4,13.9-14.6,53.9-43.6,132.9-35.2,176.5,18.7,43.6,53.9,35.2,132.9-18.7,176.5-36.5,29.5-75.9,51.1-111,45.3-29.7,5.8-58.4,7.9-82.6,3.2,1.4,1.9,2.9,3.9,4.3,5.7,59.5,73.6,141.7,37.5,215.3-22,15.4-12.5,28.1-27,37.9-43,23.8-56.4,16.6-123.7-24.5-174.6-59.5-73.6-167.5-85.1-241.1-25.6-9.1,7.4-16.9,16.3-23.4,26.3-7.6,18.6-12,39.5-13.6,61.3,15.4-26.7,38.3-48.4,67.1-57.2"
          />
          <path
            className="cls-6"
            d="M599.5,629.9c-73.7,59.5-155.8,95.6-215.3,22-1.5-1.8-2.9-3.8-4.3-5.7-12.5-2.4-23.7-6.7-33.4-13.1,7.2,15.8,15.7,30.2,25.5,42.3,59.5,73.6,141.7,37.5,215.3-22,22.7-18.4,39.5-41.3,50.1-66.5-9.9,15.9-22.5,30.5-37.9,43"
          />
          <path
            className="cls-3"
            d="M322.4,500.9c-11.8,32.5-13.8,68.1-3.8,95.6,6,16.5,15.6,28.3,27.9,36.6-17.8-39.3-26.8-87.5-24.1-132.2"
          />
          <path
            className="cls-5"
            d="M348.4,413c-15.8,24.2-24,55.1-26,87.9,3.3-9.2,7.5-18.2,12.4-26.6,1.6-21.8,6-42.7,13.6-61.3"
          />
          <path
            className="cls-8"
            d="M334.8,474.2c-4.9,8.5-9,17.4-12.4,26.6-2.7,44.7,6.3,92.9,24.1,132.2,9.6,6.5,20.9,10.7,33.4,13.1-32.1-43.5-49.6-111.2-45.1-172"
          />
          <path
            className="cls-10"
            d="M462.5,643c-16.7-2.8-32.5-11.8-46.6-29.2-39.3-48.7-51.7-146.2-14-196.7-28.8,8.8-51.7,30.5-67.1,57.2-4.5,60.8,13,128.5,45.1,172,24.2,4.7,52.9,2.6,82.6-3.2"
          />
          <path
            className="cls-5"
            d="M579.7,493c22.2,61.2-19.3,125.9-92.7,144.4-8.2,2.1-16.3,3.9-24.4,5.5,35.1,5.9,74.5-15.7,111-45.3,53.9-43.6,62.3-122.6,18.7-176.5-43.6-53.9-122.6-62.3-176.5-18.7-5.2,4.2-9.9,9.2-13.9,14.6,1.5-.5,3-.9,4.6-1.3,73.4-18.5,151,16.1,173.2,77.3"
          />
          <path
            className="cls-9"
            d="M416,613.8c14.1,17.4,29.8,26.4,46.6,29.2,8.1-1.6,16.3-3.4,24.4-5.5,73.4-18.5,114.9-83.2,92.7-144.4-22.2-61.2-99.8-95.9-173.2-77.3-1.6.4-3.1.9-4.6,1.3-37.6,50.6-25.3,148.1,14,196.7M426.2,486.7c3.2-6.8,7.6-12.6,13.2-17.2,30.4-24.6,75-19.8,99.6,10.6,24.6,30.4,19.9,75-10.6,99.6-30.4,24.6-64.4,39.5-89,9.1-1.9-2.4-3.7-5-5.4-7.8-17.8.2-32.4-5.2-38.4-21.6-8.6-23.6,4.1-61.6,30.5-72.7"
          />
          <path
            className="cls-1"
            d="M503.5,516.7c9.2,25.3-8,52-38.3,59.7-10.7,2.7-21.4,4.5-31.2,4.6,1.7,2.8,3.5,5.4,5.4,7.8,24.6,30.4,58.5,15.5,89-9.1,30.4-24.6,35.2-69.2,10.6-99.6-24.6-30.4-69.2-35.2-99.6-10.6-5.6,4.5-10,10.4-13.2,17.2,1.9-.8,3.8-1.4,5.8-2,30.3-7.7,62.4,6.7,71.6,31.9"
          />
          <path
            className="cls-7"
            d="M395.6,559.4c5.9,16.4,20.6,21.8,38.4,21.6-15.9-26-20.8-67.3-7.8-94.3-26.4,11.1-39.1,49.1-30.5,72.7"
          />
        </g>
      </svg>
    );
  }

  if (props.mode && props.mode === "light") {
    return (
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 446 446"
        {...props}
      >
        <defs>
          <style>
            {
              ".cls-1 { fill: #A56CFF;}  .cls-1, .cls-2 { stroke-width: 0px; } .cls-2 { fill: #2F007A; }"
            }
          </style>
        </defs>
        <path
          className="cls-2"
          d="M77.86,341.72V78.04h0c-43,0-77.86,34.86-77.86,77.86v188.74c0,41.39,33.55,74.94,74.94,74.94h188.75c43,0,77.86-34.86,77.86-77.86h0s-263.68,0-263.68,0Z"
        />
        <path
          className="cls-1"
          d="M344.64,0h-188.75c-43,0-77.86,34.86-77.86,77.86h208.63l-143.43,143.43,55.05,55.05,143.43-143.43v208.63h0c43,0,77.86-34.86,77.86-77.86V74.94c0-41.39-33.55-74.94-74.94-74.94Z"
        />
      </svg>
    );
  }

  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 446 446"
      {...props}
    >
      <defs>
        <style>
          {
            ".cls-1 { fill: #a56cff;}  .cls-1, .cls-2 { stroke-width: 0px; } .cls-2 { fill: #f2f2f2; }"
          }
        </style>
      </defs>
      <path
        className="cls-2"
        d="M77.86,341.72V78.04h0c-43,0-77.86,34.86-77.86,77.86v188.74c0,41.39,33.55,74.94,74.94,74.94h188.75c43,0,77.86-34.86,77.86-77.86h0s-263.68,0-263.68,0Z"
      />
      <path
        className="cls-1"
        d="M344.64,0h-188.75c-43,0-77.86,34.86-77.86,77.86h208.63l-143.43,143.43,55.05,55.05,143.43-143.43v208.63h0c43,0,77.86-34.86,77.86-77.86V74.94c0-41.39-33.55-74.94-74.94-74.94Z"
      />
    </svg>
  );
};
export default LogoIcon;
